// GA4 telemetry scaffold. Activates only when REACT_APP_GA_MEASUREMENT_ID is set (format: G-XXXXXXXXXX).
// Leave the env var blank to disable analytics entirely.

const GA_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;

let initialized = false;

export function initAnalytics() {
  if (initialized) return;
  if (!GA_ID || !/^G-[A-Z0-9]+$/i.test(GA_ID)) {
    return; // disabled — no measurement id configured
  }

  // Inject gtag loader
  const s1 = document.createElement('script');
  s1.async = true;
  s1.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(s1);

  window.dataLayer = window.dataLayer || [];
  // eslint-disable-next-line prefer-rest-params
  window.gtag = function gtag() { window.dataLayer.push(arguments); };
  window.gtag('js', new Date());
  window.gtag('config', GA_ID, { send_page_view: false });

  initialized = true;
}

export function trackPageView(tabId) {
  if (!initialized || typeof window.gtag !== 'function') return;
  window.gtag('event', 'page_view', {
    page_title: `Rishab Salgotra · ${tabId}`,
    page_location: `${window.location.origin}/#${tabId}`,
    page_path: `/${tabId}`,
  });
}

export function trackEvent(name, params = {}) {
  if (!initialized || typeof window.gtag !== 'function') return;
  window.gtag('event', name, params);
}

export const analyticsEnabled = () => Boolean(GA_ID && /^G-[A-Z0-9]+$/i.test(GA_ID));
